const LIVE_QUERY_INTERNAL = /* @__PURE__ */ Symbol(`liveQueryInternal`);
export {
  LIVE_QUERY_INTERNAL
};
//# sourceMappingURL=internal.js.map
